import Loader from './Loader.module.css';
const LoadingSpinner = () => {
  return <div className={Loader.loader}></div>;
};
export default LoadingSpinner;
